import React from "react";

import { StyledSVG } from "../StyledIcon";

export const HasuraIcon = props => {
  const { iconColor, iconWidth, iconHeight } = props;

  return (
    <StyledSVG
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      viewBox="0 0 18 18"
      fill="none"
      {...props}
    >
      <path
        d="M15.5691 6.847C15.9486 5.63613 15.7203 3.22047 14.9851 2.32865C14.8888 2.21167 14.7094 2.22838 14.6294 2.35752L13.7238 3.81451C13.5 4.10621 13.0968 4.17306 12.793 3.96948C11.8103 3.31011 10.6364 2.92725 9.375 2.92725C8.11365 2.92725 6.93974 3.31011 5.95704 3.96948C5.65468 4.17306 5.25152 4.10469 5.02622 3.81451L4.1206 2.35752C4.04056 2.22838 3.86121 2.21319 3.76487 2.32865C3.0297 3.22199 2.80144 5.63765 3.18088 6.847C3.30687 7.24961 3.34096 7.67501 3.26685 8.08825C3.19274 8.49846 3.11863 8.99375 3.11863 9.33863C3.11863 12.8801 5.91999 15.75 9.37352 15.75C12.8285 15.75 15.6284 12.8786 15.6284 9.33863C15.6284 8.99375 15.5543 8.49846 15.4802 8.08825C15.4076 7.67501 15.4431 7.24961 15.5691 6.847Z"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.25 11.5L8.25 7"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 11.5L9.375 9.75"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </StyledSVG>
  );
};
